// extracted by mini-css-extract-plugin
module.exports = {"carouselDotsContainer":"CarouselDots_carouselDotsContainer__20DbK","dot":"CarouselDots_dot__2C6kZ","hasFocus":"CarouselDots_hasFocus__1EBsx"};